require('./stepClientLogin.scss');

//@vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
const get = require('lodash/object/get');
const classNames = require('classnames');
const includes = require('lodash/collection/includes');
//@utilities
const { formatText } = require('core/i18n').i18n;
const { isInOffice } = require('utilities/contactCenter/disasterRecoveryhelper');
const securityLevelNavigationOptions = require('utilities/securityLevelNavigationOptions');

//@commons
const { OKButton } = require('components/commons/OKButton/OKButton');

//@constants
const {
    ERROR_INVALID_PASSWORD,
    ERROR_USER_BLOCKED,
} = require('constants/contactCenter/errorTypes');

//@components
const OKSelect = require('components/commons/OKSelect/OKSelect');

// @ contactCenter
const { PasswordPositions } = require('components/contactCenter/passwordPositions/passwordPositions');

class StepClientLogin extends React.Component {
    constructor(props) {
        super(props);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleFinishClick = this.handleFinishClick.bind(this);
        this.passwordRecoveryCallback = this.passwordRecoveryCallback.bind(this);
        this.handleChangeSendType = this.handleChangeSendType.bind(this);

        const sendTypeOptions = securityLevelNavigationOptions.getArrayDocuments();
        this.state = {
            positions: null,
            values: null,
            finishHasBeenPressed: false,
            dropdownOption: sendTypeOptions[0]
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.resetCounter !== nextProps.resetCounter && nextProps.resetCounter) {
            const sendTypeOptions = securityLevelNavigationOptions.getArrayDocuments();
            this.setState({
                interactionId: '',
                positions: null,
                values: null,
                certificationCheckBoxValue: false,
                finishHasBeenPressed: false,
                showModal: false,
                dropdownOption: sendTypeOptions[0]
            });
        }
    }

    getFooterClasses() {
        const inOffice = isInOffice();
        const classes = classNames('step-client-login__footer', {
            'step-client-login__footer--in-office': inOffice
        });

        return classes;
    }

    handlePasswordChange(object) {
        const { positions, values } = object;
        this.setState(() => ({
            positions,
            values,
        }));
    }

    handleChangeSendType(value) {
        this.setState({
            dropdownOption: value
        });
    }

    arrayIsFilled(values) {
        return values && !includes(values, '');
    }

    handleFinishClick() {
        const isInTheOffice = isInOffice();
        const { handleFinish, interactionId } = this.props;
        const { dropdownOption, positions, values } = this.state;
        this.setState(() => ({ finishHasBeenPressed: true }));

        if (!dropdownOption.global || (dropdownOption.global && this.arrayIsFilled(values)) || isInTheOffice) {
            handleFinish(interactionId, dropdownOption, positions, values);
        }
    }

    passwordRecoveryCallback() {
        this.props.history.push('/disasterRecovery/keys-recovery');
    }

    buildPasswordFieldContent(documentType, documentNumber) {

        const { immStepClientLogin } = this.props;
        const { dropdownOption, values, finishHasBeenPressed } = this.state;

        const isFetching = immStepClientLogin.get('isFetching');
        const passwordErrorType = immStepClientLogin.getIn([ 'passwordError', 'errorType' ]);
        const isInvalidPassword = passwordErrorType === ERROR_INVALID_PASSWORD || (!this.arrayIsFilled(values) && finishHasBeenPressed);

        return (!dropdownOption.global || isInOffice()) ? null : (
            <PasswordPositions
                className="step-client-login__password-positions"
                documentType={documentType}
                documentNumber={documentNumber}
                onInputDigit={this.handlePasswordChange}
                passwordRecoveryCallback={this.passwordRecoveryCallback}
                disabled={isFetching}
                isInvalidPasswordError={isInvalidPassword}
                isPasswordBlockedError={passwordErrorType === ERROR_USER_BLOCKED}
                onEnterKey={this.handleFinishClick}
            />
        );
    }

    render() {
        const {
            immStepClientLogin,
            immClientIdentification,
            stepNo
        } = this.props;
        const { dropdownOption } = this.state;
        const idSendOptions = securityLevelNavigationOptions.getArrayDocuments();
        const clientData = immClientIdentification.toJS();
        const titleText = formatText("stepClientLogin-title2");
        const buttonFinishText = formatText("stepClientLogin-finalButtonLabel");
        const documentTypeCode = get(clientData, 'documento.documento.tipodocumpersonacorp');
        const documentNumber = get(clientData, 'documento.documento.codigodocumpersonacorp', '--');
        const passwordFieldContent = this.buildPasswordFieldContent(documentTypeCode, documentNumber);
        const isLoading = immStepClientLogin.get('isFetching');
        const footerClasses = this.getFooterClasses();
        const buttonsClassNames = classNames('step-client-login__buttons', { 'step-client-login__buttons--in-office': isInOffice() });
        const lastStepSubtext = formatText("stepClientLogin-subtext");

        return (
            <div className="step-client-login">
                <div className="step-client-login__header">
                    <span className="wizard-step--vertical__progress-indicator">
                        {stepNo}
                    </span>
                    <h4 className="wizard-step--vertical__title step-client-login__title">
                        {titleText}
                    </h4>
                </div>
                <div className="step-client-login__body">
                    <span className="step-client-login__verify-message-text">
                        {lastStepSubtext}
                    </span>
                    <div className="step-client-login__id-wrap">
                        <OKSelect
                            name="idSend"
                            options={idSendOptions}
                            value={dropdownOption}
                            onChange={this.handleChangeSendType} />
                    </div>
                    {passwordFieldContent}
                </div>
                <div className={footerClasses}>
                    <div className={buttonsClassNames}>
                        <OKButton
                            onClick={this.handleFinishClick}
                            loading={isLoading}>
                            {buttonFinishText}
                        </OKButton>
                    </div>
                </div>
            </div>
        );
    }
}

StepClientLogin.propTypes = {
    history: PropTypes.object.isRequired,
    immClientIdentification: PropTypes.object.isRequired,
    immStepClientLogin: PropTypes.object.isRequired,
    stepNo: PropTypes.number.isRequired,
    resetCounter: PropTypes.number.isRequired,
    handleFinish: PropTypes.func.isRequired,
    interactionId: PropTypes.string.isRequired,
}

module.exports = withRouter(StepClientLogin);
